import jwts from "erayic-com-pack/encapsulation/JWT/JWTs";
import { Enum_ForecastElement, Enum_ForecastMode } from "erayic-com-pack/utils/attribute/Element";
import { GeoJsonParams, TexClipParams } from "./ModeForecast.type";

export const ModeForecastAPI = {
  /** 
   * 服务器地址
   */
  ApiPath: "https://www.scsweather.com/alonesy/TumApi",
  /** 
    *  获取气压层多层次点数据
    *  @param { GetPointInfo } option
    */
  GetPointInfo: async (option: GetPointInfo): Promise<{ [key: string]: any }> => {
    console.log(option);
    return await (await jwts.getInstance())
      .GetHttp(ModeForecastAPI.ApiPath + "/CMMS_CMADAAS_API/getPointInfo", option);
  },
  /**
   * 查询任意时间区间统计数据（单模式、单要素）
   * @param { GetAnyTimeRangeDataParams } option
   */
  GetAnyTimeRangeData: async (option: GetAnyTimeRangeDataParams): Promise<{ [key: string]: any }> => {
    return await (await jwts.getInstance())
      .GetHttp(ModeForecastAPI.ApiPath + "/CMMS_CMADAAS_API/getAnyTimeRangeData", option);
  },

  /**
   * 查询纹理图切片
   */
  GetTumSlice: async (mode: Enum_ForecastMode, ele: Enum_ForecastElement, timeDelta: number): Promise<{ success: boolean, data: TexClipParams }> => {
    return (await jwts.getInstance()).GetHttp("https://www.scsweather.com/HMS/TumApi/Weather/Texture/slice", { mode, ele, timeDelta });
    // return (await jwts.getInstance()).GetHttp("http://172.22.68.251/cmms-ws/api/CMMS_CMADAAS_API/getTumSlice", { mode, ele, timeDelta });
  },
  /**
   * 查询等值线geojson
   */
  GetGPHGeojson: async (mode: Enum_ForecastMode, ele: Enum_ForecastElement): Promise<{ success: boolean, data: GeoJsonParams }> => {
    console.log(mode, ele);
    return (await jwts.getInstance()).GetHttp("https://www.scsweather.com/HMS/TumApi/Weather/Texture/getGPHGeojson", { mode, ele });
    // return (await jwts.getInstance()).GetHttp("http://172.22.68.251/cmms-ws/api/CMMS_CMADAAS_API/getGPHGeojson", { mode, ele });
  }
}

/** 请求参数: 获取气压层多层次点数据 */
export interface GetPointInfo {
  /** 起报时间 */
  beginTime: string,
  /** 预报时间 */
  beginForeTime: string,
  /** 纬度 */
  lat: number,
  /** 经度 */
  lng: number,
  /** 要素 */
  elements?: string,
  /** 模式 */
  mode: Enum_ForecastMode,
  /** 结束预报时间，起始和结束预报时间间隔最大支持24小时 */
  endForeTime: string
}

/** 请求参数: 查询任意时间区间统计数据（单模式、单要素） */
export interface GetAnyTimeRangeDataParams {
  /** 模式 */
  mode: Enum_ForecastMode,
  /** 要素 */
  ele: Enum_ForecastElement,
  /** 起报时间 */
  dataTime?: string,
  /** 开始预报时间 */
  beginForeTime: string,
  /** 结束预报时间 */
  endForeTime: string
}